import dayjs from "dayjs";
import { get, isString } from "lodash";
import moment from "moment";
import {
  MdOutlineBadge,
  MdOutlineCake,
  MdOutlineCall,
  MdOutlineFamilyRestroom,
  MdOutlineFlaky,
  MdOutlineHealthAndSafety,
  MdOutlineLocationOn,
  MdWorkOutline,
} from "react-icons/md";
import { STEPS_KEYS } from "screens/Private/Broker/Clients/Create";
import Alert from "shared/components/Alert";
import Input from "shared/components/Input";
import Select from "shared/components/Select";
import {
  DATE_FORMAT,
  FAMILY_SITUATION,
  PROFESSIONAL_SITUATIONS,
  PROFILE_LIST,
  SITUATION_PROFESSIONAL,
  SOCIAL_REGIMES,
} from "utils/constants";
import { isMajor } from "utils/helpers/date";
import {
  bindDateInputProps,
  bindInputProps,
  bindTextFieldInputProps,
} from "utils/helpers/input";
export const step = { ADHERENT: "ADHERENT" };

const PROFILES = [
  PROFILE_LIST.PARTICULAR,
  PROFILE_LIST.RENAULT_EMPLOYEE,
  PROFILE_LIST.TNS,
];

const MUTUAL_MOBILITY_SOCIAL_REGIMES = {
  [SOCIAL_REGIMES.SECURITE_SOCIALE]: SOCIAL_REGIMES.SECURITE_SOCIALE,
  [SOCIAL_REGIMES.ALSACE_MOSELLE]: SOCIAL_REGIMES.ALSACE_MOSELLE,
};

const MUTUAL_MOBILITY_FAMILY_SITUATION = [
  FAMILY_SITUATION.SINGLE,
  FAMILY_SITUATION.MARRIED,
  FAMILY_SITUATION.PACS,
  FAMILY_SITUATION.COHABITING,
];

const MUTUAL_MOBILITY_SITUATION_PROFESSIONAL = [
  SITUATION_PROFESSIONAL.SALARIED,
  SITUATION_PROFESSIONAL.STUDENT,
  SITUATION_PROFESSIONAL.RETIRED,
  SITUATION_PROFESSIONAL.SEARCHING_FOR_A_JOB,
];

const MUTUAL_MOBILITY_RENAULT_SITUATION_PROFESSIONAL = [
  PROFESSIONAL_SITUATIONS.RETIRED,
  PROFESSIONAL_SITUATIONS.PRE_RETIRED,
  // PROFESSIONAL_SITUATIONS.UNEMPLOYED_AFTER_RIGHTS,
  // PROFESSIONAL_SITUATIONS.SUSPENDED_CONTRACT,
  // PROFESSIONAL_SITUATIONS.DISABILITY_PENSION,
  // PROFESSIONAL_SITUATIONS.DECEASED_EMPLOYEE_DEPENDENTS,
];

const Adherent = ({
  index,
  translation,
  values,
  setFieldValue,
  ...formProps
}) => {
  const birthDate = get(values, "contact.user.birthDate");
  const parsedDate = isString(birthDate) ? moment(birthDate) : birthDate;
  const isRenaultEmployee =
    get(values, "contact.fields.profile") === PROFILE_LIST.RENAULT_EMPLOYEE;
  return (
    <div className="contact-stepper" key={step.ADHERENT}>
      <div className="contact-stepper__header">
        <div className="contact-stepper__header--counter">
          <span>{index}</span>
        </div>
        <div className="contact-stepper__header--content">
          <h1 className="contact-stepper__header--content--title">
            <span>
              {translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].TITLE}
            </span>
          </h1>
          <p className="contact-stepper__header--content--description">
            {translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].DESCRIPTION}
          </p>
        </div>
      </div>
      <div className="contact-stepper__content">
        <Input
          required
          label={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.LASTNAME
              .LABEL
          }
          icon={<MdOutlineBadge size={22} />}
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.LASTNAME
              .PLACEHOLDER
          }
          {...bindTextFieldInputProps({
            name: "contact.user.lastname",
            values,
            setFieldValue,
            ...formProps,
          })}
        />
        <Input
          required
          label={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.FIRSTNAME
              .LABEL
          }
          icon={<MdOutlineBadge size={22} />}
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.FIRSTNAME
              .PLACEHOLDER
          }
          {...bindTextFieldInputProps({
            name: "contact.user.firstname",
            values,
            setFieldValue,
            ...formProps,
          })}
        />
        <Input
          required
          icon={<MdOutlineCake size={22} />}
          label={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.BIRTHDAY
              .LABEL
          }
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.BIRTHDAY
              .PLACEHOLDER
          }
          type="date"
          variant="simple"
          format={DATE_FORMAT}
          disabledDate={(current) =>
            current > moment().subtract(16, "years").endOf("day")
          }
          defaultPickerValue={
            !get(values, "contact.user.birthDate") &&
            dayjs().subtract(30, "years")
          }
          {...bindDateInputProps({
            name: "contact.user.birthDate",
            values,
            setFieldValue,
            ...formProps,
          })}
        />

        {parsedDate?.endOf("day") > isMajor && (
          <Alert
            message={
              translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.LMF_ALERT
            }
          />
        )}
        <Input
          required
          icon={<MdOutlineLocationOn size={22} />}
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .ZIPCODE.PLACEHOLDER
          }
          label={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .ZIPCODE.LABEL
          }
          optional={isRenaultEmployee}
          {...bindInputProps({
            name: "zipCode.value",
            values,
            ...formProps,
          })}
        />

        <Select
          required
          icon={<MdOutlineHealthAndSafety size={22} />}
          options={Object.entries(MUTUAL_MOBILITY_SOCIAL_REGIMES).map(
            ([key, value]) => ({
              value,
              label: translation.MUTUAL_MOBILITY_SOCIAL_REGIMES[key],
            }),
          )}
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .SOCIAL_REGIME.PLACEHOLDER
          }
          label={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .SOCIAL_REGIME.LABEL
          }
          optional={isRenaultEmployee}
          {...bindInputProps({
            name: "contact.socialRegime",
            values,
            ...formProps,
          })}
          onChange={(value) => {
            setFieldValue("contact.socialRegime", value);
          }}
        />
        <Select
          required
          icon={<MdOutlineFamilyRestroom size={22} />}
          options={MUTUAL_MOBILITY_FAMILY_SITUATION.map((value) => ({
            value,
            label:
              translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM
                .FAMILY_SITUATION.OPTIONS[value],
          }))}
          label={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM
              .FAMILY_SITUATION.LABEL
          }
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM
              .FAMILY_SITUATION.PLACEHOLDER
          }
          optional={isRenaultEmployee}
          {...bindInputProps({
            name: "contact.fields.familySituation",
            values,
            ...formProps,
          })}
          onChange={(value) => {
            setFieldValue("contact.fields.familySituation", value);
          }}
        />
        <Select
          showSearch
          required
          icon={<MdWorkOutline size={16} />}
          options={PROFILES.map((value) => ({
            value,
            label:
              translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                .PROFILES.OPTIONS[value],
          }))}
          label={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .PROFILE.LABEL
          }
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .PROFILE.PLACEHOLDER
          }
          {...bindInputProps({
            name: "contact.fields.profile",
            values,
            ...formProps,
          })}
          onChange={(value) => {
            setFieldValue("contact.fields.profile", value);
            setFieldValue("contact.fields.associationMemberType", undefined);
            setFieldValue("contact.fields.eligibleMembership", undefined);
            setFieldValue("contact.socioProfessionalCategory", undefined);
          }}
        />
        {get(values, "contact.fields.profile") ===
          PROFILE_LIST.RENAULT_EMPLOYEE && (
          <Input
            type="radio"
            variant="group"
            required
            icon={<MdOutlineFlaky size={16} />}
            label={
              translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                .ELIGIBLE_MEMBERSHIP.LABEL
            }
            values={[
              {
                value: true,
                label:
                  translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                    .ELIGIBLE_MEMBERSHIP.OPTIONS.YES,
              },
              {
                value: false,
                label:
                  translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                    .ELIGIBLE_MEMBERSHIP.OPTIONS.NO,
              },
            ]}
            {...bindInputProps({
              name: "contact.fields.eligibleMembership",
              values,
              ...formProps,
            })}
            onChange={(value) => {
              setFieldValue("contact.fields.eligibleMembership", value);
            }}
          />
        )}
        <Select
          required
          icon={<MdWorkOutline size={22} />}
          options={(isRenaultEmployee
            ? MUTUAL_MOBILITY_RENAULT_SITUATION_PROFESSIONAL
            : MUTUAL_MOBILITY_SITUATION_PROFESSIONAL
          ).map((value) => ({
            value,
            label: isRenaultEmployee
              ? translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM
                  .SITUATION_PROFESSIONAL.RENAULT_OPTIONS[value]
              : translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM
                  .SITUATION_PROFESSIONAL.OPTIONS[value],
          }))}
          label={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM
              .SITUATION_PROFESSIONAL.LABEL
          }
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM
              .SITUATION_PROFESSIONAL.PLACEHOLDER
          }
          {...bindInputProps({
            name: "contact.socioProfessionalCategory",
            values,
            ...formProps,
          })}
          onChange={(value) => {
            setFieldValue("contact.socioProfessionalCategory", value);
          }}
        />
        <Input
          optional
          icon={<MdOutlineCall size={16} />}
          type="custom"
          stripSpaces={true}
          inputMode="numeric"
          maxLength={10}
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM.PHONE
              .PLACEHOLDER
          }
          label={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM.PHONE
              .LABEL
          }
          {...bindInputProps({
            name: "phoneNumber.value",
            values,
            ...formProps,
          })}
          onChange={({ target: { value } }) => {
            setFieldValue("phoneNumber.value", value);
          }}
        />
      </div>
    </div>
  );
};
export default Adherent;
